import { API } from 'constants';

export const versionStatusLabel = {
    open: 'Open',
    merged: 'Merged',
    canceled: 'Canceled',
    deleted: 'Deleted',
    ready_for_review: 'Ready for Review',
    changes_requested: 'Changes Requested',
};

export const versionStatusBadgeColor = {
    open: 'peach',
    merged: 'lime',
    canceled: 'neutral',
    deleted: 'red',
    ready_for_review: 'blue',
    changes_requested: 'purple',
};

export const issueTypes = [
    {
        id: 'init',
        name: 'Initial File',
        description: 'Sets up the initial template file and configuration',
    },
    {
        id: 'feature',
        name: 'Feature',
        description: 'Adds new functionality or enhancements to existing template',
    },
    {
        id: 'hotfix',
        name: 'Hot Fix',
        description: 'Quickly addresses critical issues in the production environment',
    },
    {
        id: 'bugfix',
        name: 'Bug Fix',
        description: 'Corrects errors or problems found within the template',
    },
    {
        id: 'release',
        name: 'Release',
        description: 'Marks a stable version of the template ready for production',
    },
    {
        id: 'integration',
        name: 'Integration',
        description: 'Changes made to integrate related templates for production',
    },
];

export const TEMPLATES_LIBRARY_TABS = {
    goals: 'goals',
    processes: 'processes',
};

export const TEMPLATE_TYPES = {
    goal: 'goal',
    process: 'process',
};

export const successStatusChangeMessages = {
    ready_for_review: 'This issue has been successfully submitted',
    canceled: 'This issue has been successfully canceled',
};

export const templateAPIRoutes = {
    [TEMPLATE_TYPES.goal]: API.ROUTES.template.goalTemplate,
    [TEMPLATE_TYPES.process]: API.ROUTES.template.processTemplate,
};

export const versionAPIRoutes = {
    [TEMPLATE_TYPES.goal]: API.ROUTES.template.goalTemplateVersion,
    [TEMPLATE_TYPES.process]: API.ROUTES.template.processTemplateVersion,
};

export const defaultBackLinkHref = {
    [TEMPLATE_TYPES.goal]: '/templates/goals',
    [TEMPLATE_TYPES.process]: '/templates/processes',
};
